import React from 'react';
import PropTypes from 'prop-types';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Skeleton from '@mui/material/Skeleton';
import { makeStyles } from '@mui/styles';

import AdminRows from './AdminRows';

const useStyles = makeStyles(() => ({
    skeleton: {
        borderRadius: '2px',
        margin: '5px'
    }
}));

const AdminTable = ({ loading, permission, label, handleSwitchChange }) => {
    const classes = useStyles();
    return (    
        <Table className='manage-table code-mapping' aria-label='manage table'>
            <TableHead>
                <TableRow style={{ backgroundColor: '#FFF' }}>
                    <TableCell>{loading ? <Skeleton className={classes.skeleton} height={30} /> : label.title}</TableCell>
                    {label?.subTitle.map(element => 
                    <TableCell key={element.id} align='left'>{loading ? <Skeleton className={classes.skeleton} height={30} /> : element.name}</TableCell>)}
                </TableRow>
            </TableHead>
            <TableBody>
                {permission?.map(element => 
                    <AdminRows
                        key={element.id}
                        id={element.id}
                        name={element.name}
                        ruleType={element.ruleType}
                        handleSwitch={handleSwitchChange}
                        loading={loading}
                    />
                )}
            </TableBody>
        </Table>
    )
}

AdminTable.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    permission: PropTypes.array.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    label: PropTypes.object.isRequired,
    handleSwitchChange: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
};

export default AdminTable;